/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { ChangePasswordWidgetContext } from './change-password-base';
import { iamLogin } from '../main';
import { WidgetElements } from '../elements/widget-elements-base';

export class PasswordExpiredWidgetContext extends ChangePasswordWidgetContext {
  constructor(elements: WidgetElements) {
    super(elements, 'password-expired');
  }

  public override localize() {
    iamLogin.localizeElement(document.querySelector('#newPasswordTooltip .tooltiptitle'), 'newPwReq');
    iamLogin.localizeElement('pwreqLength', 'pwreqLength');
    iamLogin.localizeElement('pwreqLower', 'pwreqLower');
    iamLogin.localizeElement('pwreqUpper', 'pwreqUpper');
    iamLogin.localizeElement('pwreqDigit', 'pwreqDigit');
    iamLogin.localizeElement('pwreqSymbol', 'pwreqSymbol');
    iamLogin.localizeElement('pwreqUsername', 'pwreqUsername');
    iamLogin.localizeElement('pwreqOldpw', 'pwreqOldpw');
    iamLogin.localizeElement(document.querySelector('#repeatPasswordTooltip .tooltiptitle'), 'repeatPwReq');
    iamLogin.localizeElement('pwreqMatch', 'pwreqMatch');
  }

  public override setInitialFocus() {
    const field = this.elements.getPasswordField();
    if (field && !field.disabled) {
      field.focus();
    }
  }

  public override validateForm() {
    // disable submit button if any password field is blank or isn't showing all the "good" icons
    this.elements.getSubmitButton().disabled = this.elements.getOldPasswordField().value.length === 0 ||
      this.elements.getNewPasswordField().value.length === 0 ||
      this.elements.getConfirmPasswordField().value.length === 0 ||
      Array.from(document.querySelectorAll<HTMLElement>('.status-icon.status-good')).some(icon => {
        return icon.style.display === 'none';
      });
  }
}
